export default "__VITE_ASSET__B$uT93r$__"